import moment from 'moment';
import { timeDifference } from '../../utils/suitableDate';
import { ORDER_COMPLETED_LABEL, } from '../../constants';

export const updateTime = component => {
  const { item = {}, currentDate } = component.props;
  const { limit, datePreparationEnded, datePreparationStarted } = item;
  const differ = currentDate.diff(moment(datePreparationStarted), 'seconds');
  const { diff, diffTime } = timeDifference(currentDate, moment(datePreparationEnded));
  return { progress: (differ / limit) * 100, diff, diffTime };
};
export const getPaidStatus = (statusLabel, paymentType) => {
  if (statusLabel !== ORDER_COMPLETED_LABEL && paymentType !== 'stripe') {
    return 'Non payé';
  }
  if (paymentType === 'stripe') {
    return 'Payé en ligne';
  }
  return 'Payé';
};



